// STORE
import { createEffect, createEvent, createStore } from "effector";

import { EventStateStoreT } from "@interfaces/common";

import InternalStudyCoursesService from "@services/internal-study-courses-service";

import {
  CourseShortDataT,
  GetListPagePropsT,
  SyncCoursesPropsT,
} from "@interfaces/internal-study/courses";
import { resetAllStates } from "@store/user-store";

// LIST DATA
export const setInternalCourses = createEvent<CourseShortDataT[]>();
export const setInternalCourse = createEvent<CourseShortDataT>();

export const $InternalCourses = createStore<CourseShortDataT[]>([])
  .on(setInternalCourses, (_, newState) => newState)
  .reset(resetAllStates);
export const $InternalCourse = createStore<CourseShortDataT>(
  {} as CourseShortDataT
)
  .on(setInternalCourse, (_, newState) => newState)
  .reset(resetAllStates);

// LIST STATES
export const setInternalCoursesStateLoading = createEvent<boolean>();
export const setInternalCoursesStateError = createEvent<boolean>();
const setInternalCoursesStateFetched = createEvent<boolean>();
const setInternalCoursesStates = createEvent<EventStateStoreT>();

// INFO STATES
export const setInternalCourseStateLoading = createEvent<boolean>();
export const setInternalCourseStateError = createEvent<boolean>();
const setInternalCourseStateFetched = createEvent<boolean>();
const setInternalCourseStates = createEvent<EventStateStoreT>();

export const $InternalCoursesState = createStore<EventStateStoreT>({
  isLoading: true,
  error: false,
  isFetched: false,
})
  .on(setInternalCoursesStateLoading, (oldState, newState) => ({
    ...oldState,
    isLoading: newState,
  }))
  .on(setInternalCoursesStateError, (oldState, newState) => ({
    ...oldState,
    isLoading: false,
    error: true,
  }))
  .on(setInternalCoursesStateFetched, (oldState, newState) => ({
    ...oldState,
    isFetched: newState,
  }))
  .on(setInternalCoursesStates, (_, newState) => newState)
  .reset(resetAllStates);

export const $InternalCourseState = createStore<EventStateStoreT>({
  isLoading: true,
  error: false,
  isFetched: false,
})
  .on(setInternalCourseStateLoading, (oldState, newState) => ({
    ...oldState,
    isLoading: newState,
  }))
  .on(setInternalCourseStateError, (oldState, newState) => ({
    ...oldState,
    isLoading: false,
    error: true,
  }))
  .on(setInternalCourseStateFetched, (oldState, newState) => ({
    ...oldState,
    isFetched: newState,
  }))
  .on(setInternalCourseStates, (_, newState) => newState)
  .reset(resetAllStates);

export const fetchInternalCourses = createEffect(async () => {
  InternalStudyCoursesService.getAll((err, res) => {
    if (err || !res) {
      return setInternalCoursesStateError(true);
    }
    setInternalCourses(res.data);
    setInternalCoursesStates({
      isLoading: false,
      error: false,
      isFetched: false,
    });
  });
});

export const fetchInternalCourse = createEffect<GetListPagePropsT>(
  async ({ id }) => {
    setInternalCourseStates({
      isLoading: false,
      error: false,
      isFetched: true,
    });
    InternalStudyCoursesService.getById(id, (err, res) => {
      if (err || !res) {
        return setInternalCourseStateError(true);
      }
      setInternalCourse(res.data);
      setInternalCourseStates({
        isLoading: false,
        error: false,
        isFetched: false,
      });
    });
  }
);

export const syncInternalCourses = createEffect<SyncCoursesPropsT>(
  async ({ data, cb }) => {
    InternalStudyCoursesService.sync(data, (err, res) => {
      if (err || !res) {
        return cb(err);
      }
      setInternalCourses([...$InternalCourses.getState(), res.data]);
      cb(null);
    });
  }
);

export const removeInternalList = createEffect<(p: { id: number }) => void>(
  async ({ id }) => {
    InternalStudyCoursesService.delete(id, (err, res) => {
      if (err || !res) {
        return console.error("При удалении курса / лекции произошла ошибка");
      }
      const lists = $InternalCourses.getState();
      const listIndex = lists.findIndex((c) => c.id === id);

      lists.splice(listIndex, 1);
      setInternalCourses(Array.from(lists));
    });
  }
);
